import { render, staticRenderFns } from "./drawer_ZhuyuanAddPetCage.vue?vue&type=template&id=45c06b2a&scoped=true&"
import script from "./drawer_ZhuyuanAddPetCage.vue?vue&type=script&lang=js&"
export * from "./drawer_ZhuyuanAddPetCage.vue?vue&type=script&lang=js&"
import style0 from "./drawer_ZhuyuanAddPetCage.vue?vue&type=style&index=0&id=45c06b2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c06b2a",
  null
  
)

export default component.exports